export enum EDruhInvesticie {
    N = 'N',
    DL = 'DL',
    A = 'A',
    V = 'V',
    S = 'S',
    K = 'K',
    D = 'D',
    R = 'R',
    U = 'U',
    O = 'O'
}
